import React from 'react';
import { Route, Routes } from 'react-router-dom';
import TicketList from './TicketList';
import TicketDetailPage from './TicketDetail';

function Tickets() {
  return (
    <Routes>
      <Route index element={<TicketList />} />
      <Route path=":id" element={<TicketDetailPage />} />
    </Routes>
  );
}

export default Tickets;
